// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".name {\n  position: relative;\n}\n.name .closeBtn {\n  position: absolute;\n  top: -1rem;\n  right: 0;\n}\n\n.d-flex {\n  border-bottom: 1px solid #ccc;\n}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
